// 261023 E3-P3ka (mockup Rev 3) — Trợ lý AI gập MẶC ĐỊNH, mở bằng nút «✦ Trợ lý» ở thanh trên (không còn rail dọc 44px). 3k-c: cột bước bên trái TRỞ LẠI (User 26/10 «cột bước bên trái rõ hơn»).
// Lựa chọn «mở» từng được nhớ ở localStorage (3h2) KHÔNG còn được dùng: mỗi lần vào bàn làm việc Trợ lý đóng. «Nhờ Trợ lý sửa lỗi» vẫn tự mở (không ghi nhớ). KHÔNG hiện số gợi ý.
export const ASSISTANT_OPEN_KEY = 'talebox.adaptation.assistantOpen.v1';
export const ASSISTANT_BUTTON_LABEL = '✦ Trợ lý';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'> | null | undefined;

/** Luôn ĐÓNG lúc khởi động — kể cả khi storage còn «1» từ bản cũ (đọc có try/catch cho đủ khuôn; kết quả không phụ thuộc storage). */
export const initialAssistantOpen = (st: StorageLike): boolean => {
  try { void st?.getItem(ASSISTANT_OPEN_KEY); } catch { /* storage hỏng ⇒ vẫn đóng */ }
  return false;
};
/** Không còn nhớ «mở»: mọi lần gọi đều ghi «0» để dọn giá trị «1» cũ. Storage hỏng / vắng ⇒ bỏ qua. */
export const saveAssistantOpen = (st: StorageLike, _open: boolean): void => {
  try { st?.setItem(ASSISTANT_OPEN_KEY, '0'); } catch { /* không ghi được thì thôi */ }
};

/** Bề rộng cột bước bên trái (px) — bản cũ `868a7d0` 232, nới 280 (3k-c lượt 2: cột chật, tên tập cần 2 dòng). */
export const SIDE_WIDTH = 280;
/** Cột lưới: CỘT BƯỚC bên trái (3k-c trả lại) · vùng giữa · (Trợ lý mở ⇒ cột bề rộng kéo được; đóng ⇒ không cột, không rail). */
export const gridColsOf = (assistantOpen: boolean, assistantWidth: number, sideWidth: number = SIDE_WIDTH): string =>
  `${sideWidth}px minmax(0, 1fr)${assistantOpen ? ` ${assistantWidth}px` : ''}`;
